<form [formGroup]="form()">
    <div class="grid gap-4 mb-4">
        <spike-field-date 
            formControlName="priceDate" 
            label="Data" 
            placeholder="Seleziona data">
        </spike-field-date>

       <spike-field-number 
            formControlName="priceValue" 
            label="Valore stock"
            mode="currency" 
            currency="EUR" 
            placeholder="0.0000">
        </spike-field-number>
    </div>
</form>